// Future improvement could be to add baseClasses as a potential array - either array or string
// if (Array.isArray(baseClass)) { return [...baseClass, className].join(" ")
export function combineClasses(baseClass: string, className?: string): string {
  return className ? `${baseClass} ${className}` : baseClass;
}
